<template>
  <div :class="{
      'form-popup-overlay': true,
      'is-visible': isVisible,
      'px-5': true
    }"
    @click="hide">
    <div :class="{
        'form-popup': true,
        'form-popup-wide': true,
        'px-5': true,
        'pb-4': true,
        'pt-4': true,
        'is-loading': loading
      }"
      @click.stop>
      <h3 class="text-center mb-4">
        {{ popupTitle }}
      </h3>

      <validation-observer
        ref="contact-person-form"
        tag="form">
        <d-row>
          <d-col cols="6">
            <div class="form-group">
              <label for="name">First Name:</label>
              <d-input v-model="data.first_name" />
            </div>
          </d-col>

          <d-col cols="6">
            <div class="form-group">
              <label for="name">Last Name:</label>
              <d-input v-model="data.last_name" />
            </div>
          </d-col>
        </d-row>

        <d-row>
          <d-col cols="6">
            <div class="form-group">
              <validation-provider
                rules="contactPersonPhoneFormat"
                name="company_phone"
                v-slot="{ errors }">
                <label for="name">Company phone no:</label>
                <d-input
                  v-model="data.company_phone"
                  v-mask="'+### (###) ######'"
                  :state="errors.length ? 'invalid' : null" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>

          <d-col cols="6">
            <div class="form-group">
              <validation-provider
                rules="contactPersonPhoneFormat"
                name="mobile_phone"
                v-slot="{ errors }">
                <label for="name">Mobile phone no:</label>
                <d-input
                  v-model="data.mobile_phone"
                  v-mask="'+### (###) ######'"
                  :state="errors.length ? 'invalid' : null" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>

        <d-row>
          <d-col cols="6">
            <div class="form-group">
              <label for="name">Connection to flight:</label>
              <d-input v-model="data.flight_connection" />
            </div>
          </d-col>

          <d-col cols="6">
            <div class="form-group">
              <label for="name">ID:</label>
              <d-input v-model="data.identification" />
            </div>
          </d-col>
        </d-row>

        <d-row>
          <d-col cols="6">
            <div class="form-group">
              <label for="name">Company name:</label>
              <d-input v-model="data.company_name" />
            </div>
          </d-col>

          <d-col cols="6">
            <div class="form-group">
              <label for="name">Address:</label>
              <d-input v-model="data.address" />
            </div>
          </d-col>
        </d-row>

        <d-row>
          <d-col cols="12">
            <div class="form-group w-100">
              <validation-provider
                rules="email"
                name="email"
                v-slot="{ errors }">
                <label for="name">Email:</label>
                <d-input
                  v-model="data.email"
                  :state="errors.length ? 'invalid' : null" />
                <div class="invalid-feedback">
                  {{ errors[0] }}
                </div>
              </validation-provider>
            </div>
          </d-col>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'IsraelContactPersonPopup',
  computed: {
    popupTitle () {
      if (this.mode === 'add') {
        return 'Add contact person in Israel';
      }

      return 'Edit contact person in Israel';
    }
  },
  data () {
    return {
      isVisible: false,
      mode: 'add',
      loading: false,
      loadError: false,
      data: {
        id: false,
        is_default: false,
        first_name: '',
        last_name: '',
        company_phone: '',
        mobile_phone: '',
        flight_connection: '',
        identification: '',
        company_name: '',
        address: '',
        email: ''
      }
    };
  },
  mounted () {
    this.$bus.$on('show-israel-contact-person-popup', this.show);
  },
  methods: {
    show (mode, contactIdOrDefaultMode = false) {
      this.mode = mode;

      if (mode === 'add') {
        this.loading = false;
        this.data = {
          id: false,
          is_default: +contactIdOrDefaultMode,
          first_name: '',
          last_name: '',
          company_phone: '',
          mobile_phone: '',
          flight_connection: '',
          identification: '',
          company_name: '',
          address: '',
          email: ''
        };
      } else {
        this.loading = true;
        this.loadContactData(contactIdOrDefaultMode);
      }

      setTimeout(() => {
        this.$refs['contact-person-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    loadContactData (contactId) {
      FormUtils.loadItemData(this, {
        id: contactId,
        endpointBase: '/israel-contact-persons/item/',
        instanceFields: ['id', 'is_default', 'first_name', 'last_name', 'company_phone', 'mobile_phone', 'flight_connection', 'identification', 'company_name', 'address', 'email'],
        loadedKey: 'loaded',
        successAction: () => {
          this.loading = false;
          this.data.is_default = !!this.data.is_default;
        }
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['contact-person-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let endpointUrl = '/israel-contact-persons/store';

      if (this.mode === 'edit') {
        endpointUrl = '/israel-contact-persons/update/' + this.data.id;
      }

      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.mode === 'add' ? 'Contact person added' : 'Contact person saved',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the contact person. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('israel-contact-persons-list-reload');
        },
        failAction: () => {
          this.loading = false;
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    prepareFormData () {
      let dataToSend = {
        first_name: this.data.first_name,
        last_name: this.data.last_name,
        company_phone: this.data.company_phone,
        mobile_phone: this.data.mobile_phone,
        company_name: this.data.company_name,
        is_default: +this.data.is_default,
        flight_connection: this.data.flight_connection,
        identification: this.data.identification,
        address: this.data.address,
        email: this.data.email
      };

      return dataToSend;
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-israel-contact-person-popup', this.show);
  }
}
</script>
